<template>
    <div class="attr_dialog water-attr">
        <div class="attr_head">
            <el-form ref="form" label-width="40px" class="attr_common" label-position="left">
                <el-form-item label="ID:">
                    <el-input v-model="curProps.id" type="number"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-array">
                <el-button type="primary" icon="el-icon-check" size="mini" @click="saveProps">保存</el-button>
                <el-button type="primary" icon="el-icon-close" size="mini" @click="resetProps">恢复默认</el-button>
            </div>
        </div>

        <div class="attr_content">
            <el-form ref="form" :model="curProps" label-width="100px" :inline="true">
                <el-form-item label="标高：" class="attr-item">
                    <el-input v-model="curProps.elevation" type="number"></el-input>
                    <span class="attr_unit">m</span>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
/**
 * 水库的属性编辑框
 */
import { mapState } from 'vuex';

export default {
    name:"waterline",
    computed:{
        ...mapState('simulation',[
            'drawSource',
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
     data(){
        return {
            curProps:{
                elevation:0.0, // 标高
            } , // 当前属性
        }
    },
    mounted(){
        // 初始化属性
        this.$nextTick(()=>{
            this.init_props()
        })
    },
    methods:{
        // 初始化属性
        init_props(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            let props={};

            // 替换默认的属性
            let defaultValue=this.$store.getters['simulation/getDefault']("reservior");
            props=Object.assign({},defaultValue,nodeProps);
            
            this.curProps=props;
        },
        // 保存修改的属性
        saveProps(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            // 修改id号  
            let id=this.curProps.id;
            if(this.checkId(id)){
                this.$message({
                    message:"编号已存在",
                    type:"error",
                    duration:2000
                });
                return;
            }

            nodeProps.id=parseInt(id);
            // 重新应用属性
            let temp=Object.assign({},nodeProps,this.curProps);
            this.curFeature.setProperties(temp);
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });

            // 关闭对话框
            this.$emit("close");

        },
        // 重置属性
        resetProps(){
            // 重新获取属性
            this.init_props();
        },
        // id号判断
        checkId(id){
            let source=this.drawSource;
            let features=source.getFeatures();
            let result=false;
            features.forEach(f=>{
                let _type=f.get("_type");
                // 判断当前图形是不是节点
                if(_type!="line"){
                    let nodeid=f.get("id");
                    if(nodeid==id&&this.curFeature!=f){
                        result=true;
                        return;
                    }
                }
            });
            return result;
        }
    }
}
</script>

<style lang="scss" scoped>
.water-attr{
    position: relative;

    .attr_head{
        overflow: hidden;

        .attr_common{
            width:250px;
            float: left;
        }

        .btn-array{
            position:relative;
            float:right;

            button{
                display: block;
                margin-top: 8px;
                margin-left: 0;
                padding: 5px 3px;
                width: 90px;
                span{
                    cursor: pointer;
                }
            }

            button:first-child{
                margin-top:0;
            }
        }

        .el-input__inner{
            line-height: 35px;
            height: 35px;
        }
    }

    .attr_content{
        padding: 10px;
        border: 1px solid #246bc640;
        border-radius: 4px;
        margin-top: 10px;
        width: 600px;
        height: 320px;

        .el-form{
            display: flex;
            flex-wrap: wrap;
        }

        .attr-item{
            margin-top: 5px;
            margin-right: 0;
            flex: 1 0 50%;

            span{
                font-size: 18px;
            }

            .el-input{
                width: 150px;

                input{
                    height: 30px;
                    line-height: 30px;
                }

            }
            .el-select{
                width: 150px;
            }

            .attr_unit{
                margin-left: 10px;
            }
        }
    }
}
</style>